// extracted by mini-css-extract-plugin
export var menuItem = "B_vj d_fY d_by d_bC d_bN d_bd";
export var menuItemSub = "B_vk d_Y d_by d_bN";
export var menuMainLink = "B_vl d_fZ d_dz";
export var menuLink = "B_vm d_fZ d_dz";
export var icon = "B_pC d_bB d_bN";
export var divider = "B_vn d_bB d_bN";
export var sublinks = "B_vp";
export var link = "B_mB";
export var Link = "B_sq w_sq w_rL w_r4";